import ApiRequest from './ApiRequest';

class PlacesApi extends ApiRequest {
  getPlaces() {
    return this.get('places')
      .then(response => response.data)
      .catch(error => console.log(error)); // eslint-disable-line no-console
  }
}

export default PlacesApi;



// WEBPACK FOOTER //
// ./src/api/PlacesApi.js